module.exports = {
  apiKey: 'AIzaSyD0NdrcQYKU2JlDKtqryS26PCz9PYMbFvk',
  authDomain: 'myungsoo-8b907.firebaseapp.com',
  databaseURL: 'https://myungsoo-8b907.firebaseio.com',
  projectId: 'myungsoo-8b907',
  storageBucket: 'myungsoo-8b907.appspot.com',
  messagingSenderId: '9929677373',
};
